module.exports = __webpack_public_path__ + "static/media/film-ireland.248aca53.svg";